import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import { useSearchParams } from "react-router";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import illustration from "../assets/join-illustration.svg";

const PostRegisterThankYou = () => {
	const { t, i18n } = useTranslation();
	const currentLang = i18n?.language || "pl";

	let [searchParams, setSearchParams] = useSearchParams();

	const hasSource = searchParams.get("source");
	const frontUrl =
		currentLang === "cz"
			? "https://cargoseller.cz/"
			: "https://cargoseller.pl/";

	return (
		<>
			<CssBaseline />
			<Container
				sx={{
					backgroundColor: "#084170",
					height: "100vh",
					display: "flex",
					flexWrap: "wrap",
					gap: "38px",
					justifyContent: "center",
					alignItems: "center",
				}}
				maxWidth={false}
			>
				<img src={illustration} alt="Thank You" style={{ maxWidth: "800px" }} />
				{hasSource && hasSource === "registration" ? (
					<Box sx={{ maxWidth: "500px" }}>
						<Typography
							component="h1"
							variant="h3"
							sx={{ color: "#fff", mb: "16px" }}
						>
							{t("thanks_for_registration")}
						</Typography>
						<Typography
							component="p"
							variant="p"
							sx={{ color: "#fff", fontSize: "20px", mb: "12px" }}
						>
							{t("thanks_for_registration_info_1")}
						</Typography>
						<Typography
							component="p"
							variant="p"
							sx={{ color: "#fff", fontSize: "20px" }}
						>
							{t("thanks_for_registration_info_2")}
						</Typography>
						<a href={frontUrl}>
							<Button
								loading={false}
								type="button"
								variant="contained"
								sx={{ mt: "24px", fontSize: "18px" }}
							>
								{t("proceed_to_home_page")}
							</Button>
						</a>
					</Box>
				) : (
					<Box sx={{ maxWidth: "500px" }}>
						<Typography
							component="h1"
							variant="h3"
							sx={{ color: "#fff", mb: "16px" }}
						>
							{t("welcome")}!
						</Typography>
						<Typography
							component="p"
							variant="p"
							sx={{ color: "#fff", fontSize: "20px" }}
						>
							{t("thanks_for_registration_info_mistake")}
						</Typography>
						<a href={frontUrl}>
							<Button
								loading={false}
								type="button"
								variant="contained"
								sx={{ mt: "24px", fontSize: "18px" }}
							>
								{t("proceed_to_home_page")}
							</Button>
						</a>
					</Box>
				)}
			</Container>
		</>
	);
};

export default PostRegisterThankYou;
